const mensagemApiNode = data => {
  const mensagem = data?.mensagem;
  if (Array.isArray(mensagem)) return mensagem.join('<br/>');
  return typeof mensagem === 'string' ? mensagem : null;
};

const normalizeError = error => {
  if (error?.response) {
    return (
      error?.response?.data?.[0]?.solucao ||
      error?.response?.data?.solucao ||
      error?.response?.data?.message ||
      mensagemApiNode(error?.response?.data) ||
      'Ocorreu um erro na sua solicitação'
    );
  }

  return error?.message;
};

export default normalizeError;
